import GuestApp from "./guest-app";

export default GuestApp;